import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Card, Divider, Text } from "@nextui-org/react";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { formatDate, noop } from "../../../helpers";
import { Checkbox, DatePicker, Input, TextList } from "../../controls/formik-wrapped";
import { List } from "./list";
var DEFAULT_VALUE = {
  certification: "",
  issuer: "",
  code: "",
  description: "",
  info_url: "",
  related_skills: [],
  omit: false
};
var KEYS = Object.freeze(Object.keys(DEFAULT_VALUE));

var compareValues = function compareValues(a, b) {
  if (a === b || !a || !b) return true;
  var matches = KEYS.reduce(function (matched, key) {
    return matched && a[key] === b[key];
  }, true);
  return matches;
};

var aggregateErrors = function aggregateErrors(errors) {
  return Object.values(errors).reduce(function (errs, err) {
    return err ? [].concat(_toConsumableArray(errs), [err]) : errs;
  }, []);
};

var SingleCertification = function SingleCertification(_ref) {
  var initialValue = _ref.initialValue,
      onValueChanged = _ref.onValueChanged,
      setValidateFunction = _ref.setValidateFunction;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      validReason = _useState6[0],
      setValidReason = _useState6[1];

  var previousValue = useRef(initialValue);
  var validationSchema = useMemo(function () {
    var schema = Yup.object({
      certification: Yup.string().ensure().trim().required(),
      issuer: Yup.string().ensure().trim(),
      date_issued: Yup.date(),
      code: Yup.string().ensure().trim(),
      valid_until: Yup.date(),
      description: Yup.string(),
      info_url: Yup.string(),
      related_skills: Yup.array().of(Yup.string()),
      omit: Yup.bool()
    });
    return schema;
  }, []);
  useEffect(function () {
    if (isValid === undefined) return;
    if (compareValues(previousValue.current, currentValue)) return;
    previousValue.current = currentValue;

    if (isValid) {
      onValueChanged(currentValue);
    }
  }, [currentValue, isValid, onValueChanged, validReason]);
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValue !== null && initialValue !== void 0 ? initialValue : _objectSpread({}, DEFAULT_VALUE),
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: function onSubmit(_values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setSubmitting(false);
    }
  }, function (_ref3) {
    var isValid = _ref3.isValid,
        values = _ref3.values,
        errors = _ref3.errors,
        validateForm = _ref3.validateForm;
    setValidateFunction === null || setValidateFunction === void 0 ? void 0 : setValidateFunction(validateForm);
    setIsValid(isValid);
    if (isValid && !compareValues(currentValue, values)) setCurrentValue(values);
    var aggregatedErrors = aggregateErrors(errors);
    setValidReason(aggregatedErrors.length ? aggregatedErrors.join("; ") : undefined);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
      label: "Certification",
      name: "certification",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "certification",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Issuer",
      name: "issuer",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "issuer",
      component: "div"
    }), /*#__PURE__*/React.createElement(DatePicker, {
      name: "date_issued",
      clearable: true,
      allowSameDateSelection: true,
      views: ["year", "month"],
      label: "Date Issued"
    }), /*#__PURE__*/React.createElement(DatePicker, {
      name: "valid_until",
      clearable: true,
      allowSameDateSelection: true,
      views: ["year", "month"],
      label: "Valid Until"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Code",
      name: "code",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "code",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input.Textarea, {
      label: "Description",
      name: "description",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "description",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Information URL",
      name: "info_url",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "info_url",
      component: "div"
    }), /*#__PURE__*/React.createElement(TextList, {
      label: "Related Skills",
      name: "related_skills"
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "related_skills",
      component: "div"
    }), /*#__PURE__*/React.createElement(Checkbox, {
      label: "Don't show this certification",
      name: "omit"
    }));
  });
};

var DisplaySingleCertification = function DisplaySingleCertification(_ref4) {
  var initialValue = _ref4.initialValue;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.certification) || "Unspecified Certification"), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Text, {
    size: "sm"
  }, initialValue === null || initialValue === void 0 ? void 0 : initialValue.issuer), (initialValue === null || initialValue === void 0 ? void 0 : initialValue.date_issued) && /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, formatDate(initialValue.date_issued)), (initialValue === null || initialValue === void 0 ? void 0 : initialValue.valid_until) && /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, "Valid until ", formatDate(initialValue.valid_until))));
};

var EditSingleCertificationHeader = function EditSingleCertificationHeader(_ref5) {
  var initialValue = _ref5.initialValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.certification) || "Certification"));
};

export var CertificationEditor = function CertificationEditor(_ref6) {
  var certifications = _ref6.certifications,
      onValueChanged = _ref6.onValueChanged;
  return /*#__PURE__*/React.createElement(List, {
    individuallyEdit: true,
    display: DisplaySingleCertification,
    editHeader: EditSingleCertificationHeader,
    input: SingleCertification,
    newItem: function newItem() {
      return _objectSpread({}, DEFAULT_VALUE);
    },
    values: certifications || [],
    onValueAdded: noop,
    onValueChanged: noop,
    onValuesChanged: onValueChanged
  });
};